


















































































































import { fetchSolicitud } from '../fetchSolicitud';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { AxiosVue } from '@/AxiosVue'; //
import { ServicioProxy } from '@/config/enums'; //
import config from '@/config/index'; //
import { ComponenteBaseStepper } from '@/views/base/ComponenteBaseStepper';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';
import { EstadoInterface } from '@/interfaces/Estado';
import { LoadingService } from '@/services/loadingService';
import { EstadoEntidad } from '@/config/enums';
import { EstadosService } from '@/services/estadosService';
import { Validator } from 'vee-validate';
import { PermisoAccionVm } from '@/views/base/PermisoAccionVm';
import { Funcionalidades } from '@/config/funcionalidades';
import { CodigoAccion } from '@/views/base/VariablesPermisos';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { AccionesInterface, IAccionesPadre } from '@/interfaces/Acciones';
const { AgGridVue } = require('ag-grid-vue');
import {
  GridApi,
  ColumnApi,
  ColDef,
  CellContextMenuEvent,
  GridReadyEvent,
  SelectionChangedEvent,
  SelectionController,
  RowNode,
  CellClickedEvent,
  RowSelectedEvent,
  CellClassParams,
} from 'ag-grid-community';
import { differenceBy } from 'lodash';
import Confirmation from '@/components/Confirmation.vue';
import General from './General.vue';
import Sims from './Sims.vue';

@Component({
  components: {
    DatePicker,
    'ag-grid-vue': AgGridVue,
    'app-confirmacion': Confirmation,
    General,
    Sims,
  },
})
export default class CrearSolicitud extends ComponenteBaseStepper {
  @Prop({ required: true }) motivos: any;
  datoCreadoGeneral: any;
  desactivar: boolean = false;

  esCargaDeArchivo: boolean = false;
  esCargaArchivo(data: any) {
    this.esCargaDeArchivo = data;
  }

  cargarSimsSelected(data: any) {
    this.modalGeneral.reloaCantidad(data);
  }
  modalGeneral: any;
  modalSims: any;
  mounted() {
    this.modalGeneral = this.$refs.InformacionGeneral;
    this.modalSims = this.$refs.tablaSims;
  }

  permisosActuales: PermisoAccionVm[] = [];

  // Declarar todas las posibles subAcciones
  generalMovi: PermisoAccionVm = {
    accion: 'General',
    visible: true,
    step: 1,
    codigoAccionPadre: CodigoAccion.Crear,
  };

  simCards: PermisoAccionVm = {
    accion: 'SIM cards',
    visible: false,
    step: 2,
    codigoAccionPadre: CodigoAccion.Crear,
  };

  permisosTotales: PermisoAccionVm[] = [this.generalMovi, this.simCards];

  nextGeneral() {
    !this.generalMovi.visible;
    !this.simCards.visible;
    this.e1 = 2;
    this.actual++;
  }

  async CrearSolicitud(data: string) {
    let creacionGeneral = false;
    let crearSism = false;
    if (data == 'previous') {
      !this.generalMovi.visible;
      !this.simCards.visible;
      this.e1--;
      this.actual--;
    } else {
      if (this.modalSims.dataSelected.length == 0) {
        this.$snotify.error('Por favor, seleccione al menos una sim', {
          timeout: 3000,
        });
        return;
      }
      creacionGeneral = await this.modalGeneral.CrearSolicitudes();
    }
    if (creacionGeneral && !this.esCargaDeArchivo) {
      crearSism = this.modalSims.guardarSims(this.datoCreadoGeneral.numero);
    }
    if (creacionGeneral && this.esCargaDeArchivo) {
      crearSism = this.modalSims.generarReporte(this.datoCreadoGeneral.numero);
    }

    if (crearSism) {
      this.$emit('modalAsociacionEmit', false);
    }
  }

  // Globales
  $snotify: any;
  e1: number = 1;
  actual: number = 1;
  btnText: string = 'Continuar';
  btnClass: string = 'btn-continuar';
  dialog: boolean = true;
  validForm: boolean = true;
  loadingService = new LoadingService();
  btnBloquear: boolean = false;
  dialogConfirmacion: boolean = false;
  dialogConfirmacionClose: boolean = false;
  mensajeConfirmacion: any = '';

  //Interface
  editedItem: IFuncionalidad = {};

  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'ModuloAccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  //@Watch('show')
  async onPropertyChanged(value: boolean, oldValue: boolean) {
    this.dialog = value; //Estado Activo0
  }

  closeModal(val: boolean) {
    document.getElementById('cardDivModulos').scrollIntoView(true);
    this.editedItem = {};
    this.e1 = 1;
    this.$emit('modalAsociacionEmit', false);
    this.dialog = false;
    this.btnClass = 'btn-continuar';
  }

  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = false;
    if (val) {
      this.closeModal(false);
    }
  }

  cierraMenu() {
    var appBanners = document.getElementsByClassName(
      'ag-menu'
    ) as HTMLCollectionOf<HTMLElement>;
    if (appBanners.length > 0) {
      appBanners[0].remove();
    }
  }
}
